// test2480
(2480 && 0);
